{
  function checkAllColsHaveXsClass(){
    // Warn the dev about common mistakes
    jQuery(".row > *").each(function(){
      if(this.className.indexOf('col-xs-') == -1 && this.tagName != "TEMPLATE" && this?.type != "hidden"){
        console.warn(this, ' needs an extra small class on it')
      }
    })
  }

  function checkDateTimeForValidTag(){
    // Check the entire page's content for ##:## and see if it is wrapped in a <time> element for screen readers
    const timeRegex = /\d{1,2}:\d{2}/

    document.querySelectorAll('main section').forEach(el => {
      if(timeRegex.test(el.innerText)){
        const timeEl = el.querySelectorAll('time')
        if(!timeEl.length){
          console.warn(el, " possibly needs a <time> element around time text")
        }
      }
    })
  }

  function hideBrs(){
    // Aria hide any <br> because they are bad for screen readers
    const brs = document.querySelectorAll('br')
    if(brs.length){
      brs.forEach(br => br.setAttribute('aria-hidden', true))
    }
  }

  function hideHrs(){
    // Aria hide any <br> because they are bad for screen readers
    const hrs = document.querySelectorAll('hr')
    if(hrs.length){
      hrs.forEach(hr => hr.setAttribute('aria-hidden', true))
    }
  }

  function hidePipes(){
    // Aria hide any pipe characters (|) because they are bad for screen readers
    jQuery("p:contains(|),h1:contains(|),h2:contains(|),h3:contains(|),h4:contains(|),h5:contains(|),h6:contains(|),a:contains(|)").each(function() {
      let html = jQuery(this).html()
      jQuery(this).html(html.replaceAll('|', '<span aria-hidden="true">|</span>'))
    })  
  }

  function checkHeadingOrder(){
    const h1s = document.querySelectorAll('h1')
    if(h1s.length > 1){
      let visibleH1s = []
      h1s.forEach(h1 => {
        if(h1.offsetHeight && !h1.closest("[aria-hidden='true']")){
          visibleH1s.push(h1)
        }
      })
      if(visibleH1s.length > 1){
        console.warn("More than one H1 is on the page!!", visibleH1s)
      }
    }
  }

  function fixWPsSkipToMain(){
    const main = document.querySelector('main')
    const skipLink = document.querySelector('.skip-link')
    if(main && skipLink){
      skipLink.addEventListener('click', e => {
        console.log('focus main')
        main.setAttribute('tabindex', -1)
        setTimeout(() => main.focus())
      })
    }
  }

  function adaHelpers(){
    fixWPsSkipToMain()
    checkAllColsHaveXsClass()
    checkDateTimeForValidTag()
    hideBrs()
    hideHrs()
    hidePipes()
    checkHeadingOrder()
  }

  adaHelpers()
}